import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getReportAttendanceHostDetail = async (queries) => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `attendance-report/host/details?${queries}` });
  
  return data;
};

export default getReportAttendanceHostDetail;
